import { Link } from 'react-router-dom';
import { SyncStatusBadge } from '@/offline/SyncStatusBadge';
import { NotificationBell } from '@/features/notifications/components/NotificationBell';
import { NadcAppsLauncher } from './NadcAppsLauncher';

/**
 * The right end of the desktop's top row (compact chrome, 2026-10-10): the
 * connection light, the bell and the NADC apps button, in that order, on
 * every route.
 *
 * - All three stay mounted wherever you are: the bell polls the unread count
 *   and the NADC apps button asks the portal for its list as the shell
 *   mounts, so both answers are in before anyone opens them.
 * - The light is the only visible offline signal (ConnectivityIndicator is
 *   for screen readers), so it is never left off a route. It links to the
 *   Sync Center — except for an operator, whose nav is My job alone (spec
 *   §2.3): the light still shows the queue, the link does not.
 * - Nothing here repeats a nav or tab label as visible text ("Sync",
 *   "Inbox"): the page's own menus already say those.
 */
export function ShellStatus({ operator }: { operator: boolean }) {
  return (
    <div data-testid="shell-status" className="flex shrink-0 items-center gap-1">
      {operator ? (
        <SyncStatusBadge variant="bar" />
      ) : (
        <Link
          to="/sync"
          title="Sync Center"
          className="flex h-9 items-center rounded-md px-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-safety-500 [@media(pointer:coarse)]:h-11"
        >
          <SyncStatusBadge variant="bar" />
        </Link>
      )}
      <NotificationBell />
      <NadcAppsLauncher />
    </div>
  );
}
